export const soDetailModel = (id) => ({
    id: id,
    dtId: null,
    docId: null,
    line: null,
    itemId: null,
    itemCode: null,
    itemName: null,
    itemQty: null,
    itemUnit: null,
    itemPriceUnit: null,
    itemDiscount: null,
    itemDisType: null,
    itemTotal: null,
    itemStatus: null,
    dsSeq: null,
    whId: null,
    itemRecQty: null,

    // ใช้สำหรับแสดงค่าเฉยๆ นะจ๊ะ
    itemOnHand: null
});